// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__wAp8+","menu_btn":"SideMenu_menu_btn__xJPna","menu_btn_active":"SideMenu_menu_btn_active__ztehx"};